<app-button [button]="downloadButton">
</app-button>
<br>
<div *ngIf="loading" class="info-msg">Your presentation is loading. This may take 2-3 minutes depending up on the network ...</div>
<br>
<div *ngIf="loading" class="info-msg">You can also download the presentation by clicking above download button.</div>

<ngx-doc-viewer [url]="productDemoURL"
				viewer="google"
				style="width:100%;height:100vh;"
				(loaded)="onDocLoaded()">
</ngx-doc-viewer>
